
/* styles */
require("!!../../../node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?sourceMap!../../../node_modules/vue-loader/lib/style-rewriter?id=data-v-cfc22cf6&scoped=true!../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./ArticlesReport.vue")

var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./ArticlesReport.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-cfc22cf6!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./ArticlesReport.vue"),
  /* scopeId */
  "data-v-cfc22cf6",
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Article/ArticlesReport.vue
// module id = 564
// module chunks = 0